import { render } from "./LetterboxAccess.vue?vue&type=template&id=cad25048"
import script from "./LetterboxAccess.vue?vue&type=script&lang=js"
export * from "./LetterboxAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__